import { useCallback, useEffect, useState } from 'react'
import { doc, getDoc } from 'firebase/firestore/lite'
import { db } from '../lib/firebase'

/**
 * Lista de imágenes que rotan en el hero (colección `configuracion`, doc
 * `hero`). Lectura puntual, igual que useProductos: son pocas imágenes que
 * casi no cambian. Si el doc no existe todavía (sitio recién desplegado,
 * antes de guardar nada desde el panel admin) devuelve un array vacío — el
 * componente Hero decide el fallback visual.
 */
export function useHero() {
  const [imagenes, setImagenes] = useState([])
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState(null)

  const recargar = useCallback(() => {
    let vigente = true
    setCargando(true)
    setError(null)

    getDoc(doc(db, 'configuracion', 'hero'))
      .then((snap) => {
        if (!vigente) return
        const datos = snap.exists() ? snap.data().imagenes : null
        setImagenes(Array.isArray(datos) ? datos : [])
        setCargando(false)
      })
      .catch((err) => {
        if (!vigente) return
        console.error('useHero:', err)
        setError('No pudimos cargar las imágenes del hero.')
        setCargando(false)
      })

    return () => {
      vigente = false
    }
  }, [])

  useEffect(() => recargar(), [recargar])

  return { imagenes, cargando, error, recargar }
}
